var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrepayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00341797,
    y: 0.00341797,
    width: 48.0046,
    height: 48.0046,
    rx: 24.0023,
    fill: "#45B549"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 15.75C32.1641 15.75 32.75 16.3359 32.75 17C32.75 17.7031 32.1641 18.25 31.5 18.25H17.125C16.7734 18.25 16.5 18.5625 16.5 18.875C16.5 19.2266 16.7734 19.5 17.125 19.5H31.5C32.8672 19.5 34 20.6328 34 22V30.75C34 32.1562 32.8672 33.25 31.5 33.25H16.5C15.0938 33.25 14 32.1562 14 30.75V18.25C14 16.8828 15.0938 15.75 16.5 15.75H31.5ZM30.25 27.625C30.9141 27.625 31.5 27.0781 31.5 26.375C31.5 25.7109 30.9141 25.125 30.25 25.125C29.5469 25.125 29 25.7109 29 26.375C29 27.0781 29.5469 27.625 30.25 27.625Z",
    fill: "#FCFCFC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepayIcon);
export default __webpack_public_path__ + "static/media/PrepayIcon.70e3384ca177c3783bcb05759bed1c09.svg";
export { ForwardRef as ReactComponent };